import { type ReactNode, useEffect, useState } from "react";

import {
  applyTheme,
  THEME_STORAGE_KEY,
  ThemeContext,
  type ThemeChoice,
  storedTheme,
} from "./theme-context";

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [choice, setChoice] = useState<ThemeChoice>(storedTheme);

  useEffect(() => {
    applyTheme(choice);
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, choice);
    } catch {
      // not kept, but the theme still applies for this visit
    }
    if (choice !== "system") {
      return undefined;
    }
    const media = window.matchMedia("(prefers-color-scheme: dark)");
    const follow = () => {
      applyTheme("system");
    };
    media.addEventListener("change", follow);
    return () => {
      media.removeEventListener("change", follow);
    };
  }, [choice]);

  return <ThemeContext.Provider value={{ choice, setChoice }}>{children}</ThemeContext.Provider>;
}
